// Generated by scripts/gen-emoji-map.mjs — do not edit by hand.
// Regenerate after upgrading @tiptap-pro/extension-emoji:
//   node scripts/gen-emoji-map.mjs && pnpm exec biome check --write src/postContentElement/components/nodes/emoji/emojiShortcodeMap.generated.ts
// Emoji.spec.tsx asserts parity with the extension's dataset.
export const emojiShortcodeMap: Record<string, string> = {
  '100': '💯',
  '1234': '🔢',
  regional_indicator_a: '🇦',
  regional_indicator_b: '🇧',
  regional_indicator_c: '🇨',
  regional_indicator_d: '🇩',
  regional_indicator_e: '🇪',
  regional_indicator_f: '🇫',
  regional_indicator_g: '🇬',
  regional_indicator_h: '🇭',
  regional_indicator_i: '🇮',
  regional_indicator_j: '🇯',
  regional_indicator_k: '🇰',
  regional_indicator_l: '🇱',
  regional_indicator_m: '🇲',
  regional_indicator_n: '🇳',
  regional_indicator_o: '🇴',
  regional_indicator_p: '🇵',
  regional_indicator_q: '🇶',
  regional_indicator_r: '🇷',
  regional_indicator_s: '🇸',
  regional_indicator_t: '🇹',
  regional_indicator_u: '🇺',
  regional_indicator_v: '🇻',
  regional_indicator_w: '🇼',
  regional_indicator_x: '🇽',
  regional_indicator_y: '🇾',
  regional_indicator_z: '🇿',
  grinning: '😀',
  grinning_face: '😀',
  smiley: '😃',
  grinning_face_with_big_eyes: '😃',
  smile: '😄',
  grinning_face_with_closed_eyes: '😄',
  grin: '😁',
  beaming_face: '😁',
  laughing: '😆',
  lol: '😆',
  satisfied: '😆',
  squinting_face: '😆',
  sweat_smile: '😅',
  grinning_face_with_sweat: '😅',
  rofl: '🤣',
  joy: '😂',
  lmao: '😂',
  tears_of_joy: '😂',
  slightly_smiling_face: '🙂',
  upside_down_face: '🙃',
  melting_face: '🫠',
  melt: '🫠',
  wink: '😉',
  winking_face: '😉',
  blush: '😊',
  smiling_face_with_closed_eyes: '😊',
  innocent: '😇',
  halo: '😇',
  smiling_face_with_three_hearts: '🥰',
  smiling_face_with_3_hearts: '🥰',
  heart_eyes: '😍',
  smiling_face_with_heart_eyes: '😍',
  star_struck: '🤩',
  kissing_heart: '😘',
  blowing_a_kiss: '😘',
  kissing: '😗',
  kissing_face: '😗',
  relaxed: '☺',
  smiling_face: '☺',
  kissing_closed_eyes: '😚',
  kissing_face_with_closed_eyes: '😚',
  kissing_smiling_eyes: '😙',
  kissing_face_with_smiling_eyes: '😙',
  smiling_face_with_tear: '🥲',
  yum: '😋',
  savoring_food: '😋',
  stuck_out_tongue: '😛',
  face_with_tongue: '😛',
  stuck_out_tongue_winking_eye: '😜',
  zany_face: '🤪',
  zany: '🤪',
  stuck_out_tongue_closed_eyes: '😝',
  money_mouth_face: '🤑',
  hugs: '🤗',
  hug: '🤗',
  hugging: '🤗',
  hugging_face: '🤗',
  hand_over_mouth: '🤭',
  face_with_hand_over_mouth: '🤭',
  face_with_open_eyes_and_hand_over_mouth: '🫢',
  face_with_open_eyes_hand_over_mouth: '🫢',
  gasp: '🫢',
  face_with_peeking_eye: '🫣',
  peek: '🫣',
  shushing_face: '🤫',
  shush: '🤫',
  thinking: '🤔',
  thinking_face: '🤔',
  wtf: '🤔',
  saluting_face: '🫡',
  salute: '🫡',
  zipper_mouth_face: '🤐',
  zipper_mouth: '🤐',
  raised_eyebrow: '🤨',
  face_with_raised_eyebrow: '🤨',
  neutral_face: '😐',
  neutral: '😐',
  expressionless: '😑',
  expressionless_face: '😑',
  no_mouth: '😶',
  dotted_line_face: '🫥',
  face_in_clouds: '😶‍🌫',
  in_clouds: '😶‍🌫',
  smirk: '😏',
  smirking: '😏',
  smirking_face: '😏',
  unamused: '😒',
  unamused_face: '😒',
  roll_eyes: '🙄',
  rolling_eyes: '🙄',
  grimacing: '😬',
  grimacing_face: '😬',
  face_exhaling: '😮‍💨',
  exhale: '😮‍💨',
  exhaling: '😮‍💨',
  lying_face: '🤥',
  lying: '🤥',
  shaking_face: '🫨',
  shaking: '🫨',
  head_shaking_horizontally: '🙂‍↔',
  head_shaking_vertically: '🙂‍↕',
  relieved: '😌',
  relieved_face: '😌',
  pensive: '😔',
  pensive_face: '😔',
  sleepy: '😪',
  sleepy_face: '😪',
  drooling_face: '🤤',
  drooling: '🤤',
  sleeping: '😴',
  sleeping_face: '😴',
  mask: '😷',
  medical_mask: '😷',
  face_with_thermometer: '🤒',
  face_with_head_bandage: '🤕',
  nauseated_face: '🤢',
  nauseated: '🤢',
  vomiting_face: '🤮',
  face_vomiting: '🤮',
  vomiting: '🤮',
  sneezing_face: '🤧',
  sneezing: '🤧',
  hot_face: '🥵',
  hot: '🥵',
  cold_face: '🥶',
  cold: '🥶',
  woozy_face: '🥴',
  woozy: '🥴',
  dizzy_face: '😵',
  knocked_out: '😵',
  face_with_spiral_eyes: '😵‍💫',
  dizzy_eyes: '😵‍💫',
  exploding_head: '🤯',
  cowboy_hat_face: '🤠',
  cowboy: '🤠',
  cowboy_face: '🤠',
  partying_face: '🥳',
  hooray: '🥳',
  partying: '🥳',
  disguised_face: '🥸',
  disguised: '🥸',
  sunglasses: '😎',
  smiling_face_with_sunglasses: '😎',
  sunglasses_cool: '😎',
  too_cool: '😎',
  nerd_face: '🤓',
  nerd: '🤓',
  monocle_face: '🧐',
  face_with_monocle: '🧐',
  confused: '😕',
  confused_face: '😕',
  face_with_diagonal_mouth: '🫤',
  worried: '😟',
  worried_face: '😟',
  slightly_frowning_face: '🙁',
  frowning_face: '☹',
  white_frowning_face: '☹',
  open_mouth: '😮',
  face_with_open_mouth: '😮',
  hushed: '😯',
  hushed_face: '😯',
  astonished: '😲',
  astonished_face: '😲',
  flushed: '😳',
  flushed_face: '😳',
  pleading_face: '🥺',
  pleading: '🥺',
  face_holding_back_tears: '🥹',
  watery_eyes: '🥹',
  frowning: '😦',
  anguished: '😧',
  anguished_face: '😧',
  fearful: '😨',
  fearful_face: '😨',
  cold_sweat: '😰',
  anxious: '😰',
  anxious_face: '😰',
  disappointed_relieved: '😥',
  sad_relieved_face: '😥',
  cry: '😢',
  crying_face: '😢',
  sob: '😭',
  loudly_crying_face: '😭',
  scream: '😱',
  screaming_in_fear: '😱',
  confounded: '😖',
  confounded_face: '😖',
  persevere: '😣',
  persevering_face: '😣',
  disappointed: '😞',
  disappointed_face: '😞',
  sweat: '😓',
  downcast_face: '😓',
  weary: '😩',
  weary_face: '😩',
  tired_face: '😫',
  tired: '😫',
  yawning_face: '🥱',
  yawn: '🥱',
  yawning: '🥱',
  triumph: '😤',
  nose_steam: '😤',
  pout: '😡',
  pouting_face: '😡',
  rage: '😡',
  angry: '😠',
  angry_face: '😠',
  cursing_face: '🤬',
  censored: '🤬',
  face_with_symbols_on_mouth: '🤬',
  smiling_imp: '😈',
  imp: '👿',
  angry_imp: '👿',
  skull: '💀',
  skull_and_crossbones: '☠',
  hankey: '💩',
  poop: '💩',
  shit: '💩',
  clown_face: '🤡',
  clown: '🤡',
  japanese_ogre: '👹',
  ogre: '👹',
  japanese_goblin: '👺',
  goblin: '👺',
  ghost: '👻',
  alien: '👽',
  space_invader: '👾',
  alien_monster: '👾',
  robot: '🤖',
  robot_face: '🤖',
  smiley_cat: '😺',
  grinning_cat: '😺',
  smile_cat: '😸',
  grinning_cat_with_closed_eyes: '😸',
  joy_cat: '😹',
  tears_of_joy_cat: '😹',
  heart_eyes_cat: '😻',
  smiling_cat_with_heart_eyes: '😻',
  smirk_cat: '😼',
  wry_smile_cat: '😼',
  kissing_cat: '😽',
  scream_cat: '🙀',
  weary_cat: '🙀',
  crying_cat_face: '😿',
  crying_cat: '😿',
  pouting_cat: '😾',
  see_no_evil: '🙈',
  hear_no_evil: '🙉',
  speak_no_evil: '🙊',
  love_letter: '💌',
  cupid: '💘',
  heart_with_arrow: '💘',
  gift_heart: '💝',
  heart_with_ribbon: '💝',
  sparkling_heart: '💖',
  heartpulse: '💗',
  growing_heart: '💗',
  heartbeat: '💓',
  beating_heart: '💓',
  revolving_hearts: '💞',
  two_hearts: '💕',
  heart_decoration: '💟',
  heavy_heart_exclamation: '❣',
  heart_exclamation: '❣',
  broken_heart: '💔',
  heart_on_fire: '❤‍🔥',
  mending_heart: '❤‍🩹',
  heart: '❤',
  red_heart: '❤',
  pink_heart: '🩷',
  orange_heart: '🧡',
  yellow_heart: '💛',
  green_heart: '💚',
  blue_heart: '💙',
  light_blue_heart: '🩵',
  purple_heart: '💜',
  brown_heart: '🤎',
  black_heart: '🖤',
  grey_heart: '🩶',
  gray_heart: '🩶',
  white_heart: '🤍',
  kiss: '💋',
  anger: '💢',
  boom: '💥',
  collision: '💥',
  dizzy: '💫',
  sweat_drops: '💦',
  dash: '💨',
  dashing_away: '💨',
  hole: '🕳',
  speech_balloon: '💬',
  eye_speech_bubble: '👁‍🗨️',
  eye_in_speech_bubble: '👁‍🗨️',
  left_speech_bubble: '🗨',
  right_anger_bubble: '🗯',
  thought_balloon: '💭',
  zzz: '💤',
  wave: '👋',
  waving_hand: '👋',
  raised_back_of_hand: '🤚',
  raised_hand_with_fingers_splayed: '🖐',
  hand: '✋',
  high_five: '✋',
  raised_hand: '✋',
  vulcan_salute: '🖖',
  vulcan: '🖖',
  rightwards_hand: '🫱',
  leftwards_hand: '🫲',
  palm_down_hand: '🫳',
  palm_down: '🫳',
  palm_up_hand: '🫴',
  palm_up: '🫴',
  leftwards_pushing_hand: '🫷',
  rightwards_pushing_hand: '🫸',
  ok_hand: '👌',
  pinched_fingers: '🤌',
  pinch: '🤌',
  pinching_hand: '🤏',
  v: '✌',
  victory: '✌',
  crossed_fingers: '🤞',
  fingers_crossed: '🤞',
  hand_with_index_finger_and_thumb_crossed: '🫰',
  love_you_gesture: '🤟',
  metal: '🤘',
  sign_of_the_horns: '🤘',
  call_me_hand: '🤙',
  point_left: '👈',
  point_right: '👉',
  point_up_2: '👆',
  point_up: '👆',
  fu: '🖕',
  middle_finger: '🖕',
  point_down: '👇',
  index_pointing_at_the_viewer: '🫵',
  point_forward: '🫵',
  '+1': '👍',
  thumbsup: '👍',
  yes: '👍',
  '-1': '👎',
  no: '👎',
  thumbsdown: '👎',
  fist: '✊',
  facepunch: '👊',
  punch: '👊',
  fist_left: '🤛',
  left_facing_fist: '🤛',
  fist_right: '🤜',
  right_facing_fist: '🤜',
  clap: '👏',
  clapping_hands: '👏',
  raised_hands: '🙌',
  heart_hands: '🫶',
  open_hands: '👐',
  palms_up_together: '🤲',
  handshake: '🤝',
  pray: '🙏',
  folded_hands: '🙏',
  writing_hand: '✍',
  nail_care: '💅',
  nail_polish: '💅',
  selfie: '🤳',
  muscle: '💪',
  right_bicep: '💪',
  mechanical_arm: '🦾',
  mechanical_leg: '🦿',
  leg: '🦵',
  foot: '🦶',
  ear: '👂',
  ear_with_hearing_aid: '🦻',
  hearing_aid: '🦻',
  nose: '👃',
  brain: '🧠',
  anatomical_heart: '🫀',
  lungs: '🫁',
  tooth: '🦷',
  bone: '🦴',
  eyes: '👀',
  eye: '👁',
  tongue: '👅',
  lips: '👄',
  mouth: '👄',
  biting_lip: '🫦',
  baby: '👶',
  child: '🧒',
  boy: '👦',
  girl: '👧',
  adult: '🧑',
  blond_haired_person: '👱',
  blond_haired: '👱',
  man: '👨',
  bearded_person: '🧔',
  person_bearded: '🧔',
  man_beard: '🧔‍♂',
  man_bearded: '🧔‍♂',
  woman_beard: '🧔‍♀',
  woman_bearded: '🧔‍♀',
  red_haired_man: '👨‍🦰',
  man_red_haired: '👨‍🦰',
  curly_haired_man: '👨‍🦱',
  man_curly_haired: '👨‍🦱',
  white_haired_man: '👨‍🦳',
  man_white_haired: '👨‍🦳',
  bald_man: '👨‍🦲',
  man_bald: '👨‍🦲',
  woman: '👩',
  red_haired_woman: '👩‍🦰',
  woman_red_haired: '👩‍🦰',
  person_red_hair: '🧑‍🦰',
  red_haired: '🧑‍🦰',
  curly_haired_woman: '👩‍🦱',
  woman_curly_haired: '👩‍🦱',
  person_curly_hair: '🧑‍🦱',
  curly_haired: '🧑‍🦱',
  white_haired_woman: '👩‍🦳',
  woman_white_haired: '👩‍🦳',
  person_white_hair: '🧑‍🦳',
  white_haired: '🧑‍🦳',
  bald_woman: '👩‍🦲',
  woman_bald: '👩‍🦲',
  person_bald: '🧑‍🦲',
  bald: '🧑‍🦲',
  blond_haired_woman: '👱‍♀',
  woman_blond_haired: '👱‍♀',
  blond_haired_man: '👱‍♂',
  man_blond_haired: '👱‍♂',
  older_adult: '🧓',
  older_man: '👴',
  older_woman: '👵',
  frowning_person: '🙍',
  person_frowning: '🙍',
  frowning_man: '🙍‍♂',
  man_frowning: '🙍‍♂',
  frowning_woman: '🙍‍♀',
  woman_frowning: '🙍‍♀',
  person_pouting: '🙎',
  pouting: '🙎',
  pouting_man: '🙎‍♂',
  man_pouting: '🙎‍♂',
  pouting_woman: '🙎‍♀',
  woman_pouting: '🙎‍♀',
  no_good: '🙅',
  person_gesturing_no: '🙅',
  ng_man: '🙅‍♂',
  man_gesturing_no: '🙅‍♂',
  ng_woman: '🙅‍♀',
  woman_gesturing_no: '🙅‍♀',
  ok_person: '🙆',
  all_good: '🙆',
  person_gesturing_ok: '🙆',
  ok_man: '🙆‍♂',
  man_gesturing_ok: '🙆‍♂',
  ok_woman: '🙆‍♀',
  woman_gesturing_ok: '🙆‍♀',
  information_desk_person: '💁',
  person_tipping_hand: '💁',
  sassy_man: '💁‍♂',
  man_tipping_hand: '💁‍♂',
  sassy_woman: '💁‍♀',
  woman_tipping_hand: '💁‍♀',
  raising_hand: '🙋',
  person_raising_hand: '🙋',
  raising_hand_man: '🙋‍♂',
  man_raising_hand: '🙋‍♂',
  raising_hand_woman: '🙋‍♀',
  woman_raising_hand: '🙋‍♀',
  deaf_person: '🧏',
  deaf_man: '🧏‍♂',
  deaf_woman: '🧏‍♀',
  bow: '🙇',
  person_bowing: '🙇',
  bowing_man: '🙇‍♂',
  man_bowing: '🙇‍♂',
  bowing_woman: '🙇‍♀',
  woman_bowing: '🙇‍♀',
  facepalm: '🤦',
  person_facepalming: '🤦',
  man_facepalming: '🤦‍♂',
  woman_facepalming: '🤦‍♀',
  shrug: '🤷',
  person_shrugging: '🤷',
  man_shrugging: '🤷‍♂',
  woman_shrugging: '🤷‍♀',
  health_worker: '🧑‍⚕',
  man_health_worker: '👨‍⚕',
  woman_health_worker: '👩‍⚕',
  student: '🧑‍🎓',
  man_student: '👨‍🎓',
  woman_student: '👩‍🎓',
  teacher: '🧑‍🏫',
  man_teacher: '👨‍🏫',
  woman_teacher: '👩‍🏫',
  judge: '🧑‍⚖',
  man_judge: '👨‍⚖',
  woman_judge: '👩‍⚖',
  farmer: '🧑‍🌾',
  man_farmer: '👨‍🌾',
  woman_farmer: '👩‍🌾',
  cook: '🧑‍🍳',
  man_cook: '👨‍🍳',
  woman_cook: '👩‍🍳',
  mechanic: '🧑‍🔧',
  man_mechanic: '👨‍🔧',
  woman_mechanic: '👩‍🔧',
  factory_worker: '🧑‍🏭',
  man_factory_worker: '👨‍🏭',
  woman_factory_worker: '👩‍🏭',
  office_worker: '🧑‍💼',
  man_office_worker: '👨‍💼',
  woman_office_worker: '👩‍💼',
  scientist: '🧑‍🔬',
  man_scientist: '👨‍🔬',
  woman_scientist: '👩‍🔬',
  technologist: '🧑‍💻',
  man_technologist: '👨‍💻',
  woman_technologist: '👩‍💻',
  singer: '🧑‍🎤',
  man_singer: '👨‍🎤',
  woman_singer: '👩‍🎤',
  artist: '🧑‍🎨',
  man_artist: '👨‍🎨',
  woman_artist: '👩‍🎨',
  pilot: '🧑‍✈',
  man_pilot: '👨‍✈',
  woman_pilot: '👩‍✈',
  astronaut: '🧑‍🚀',
  man_astronaut: '👨‍🚀',
  woman_astronaut: '👩‍🚀',
  firefighter: '🧑‍🚒',
  man_firefighter: '👨‍🚒',
  woman_firefighter: '👩‍🚒',
  cop: '👮',
  police_officer: '👮',
  policeman: '👮‍♂',
  man_police_officer: '👮‍♂',
  policewoman: '👮‍♀',
  woman_police_officer: '👮‍♀',
  detective: '🕵',
  male_detective: '🕵‍♂️',
  man_detective: '🕵‍♂️',
  female_detective: '🕵‍♀️',
  woman_detective: '🕵‍♀️',
  guard: '💂',
  guardsman: '💂‍♂',
  man_guard: '💂‍♂',
  guardswoman: '💂‍♀',
  woman_guard: '💂‍♀',
  ninja: '🥷',
  construction_worker: '👷',
  construction_worker_man: '👷‍♂',
  man_construction_worker: '👷‍♂',
  construction_worker_woman: '👷‍♀',
  woman_construction_worker: '👷‍♀',
  person_with_crown: '🫅',
  royalty: '🫅',
  prince: '🤴',
  princess: '👸',
  person_with_turban: '👳',
  person_wearing_turban: '👳',
  man_with_turban: '👳‍♂',
  man_wearing_turban: '👳‍♂',
  woman_with_turban: '👳‍♀',
  woman_wearing_turban: '👳‍♀',
  man_with_gua_pi_mao: '👲',
  person_with_skullcap: '👲',
  woman_with_headscarf: '🧕',
  person_in_tuxedo: '🤵',
  man_in_tuxedo: '🤵‍♂',
  woman_in_tuxedo: '🤵‍♀',
  person_with_veil: '👰',
  man_with_veil: '👰‍♂',
  bride_with_veil: '👰‍♀',
  woman_with_veil: '👰‍♀',
  pregnant_woman: '🤰',
  pregnant_man: '🫃',
  pregnant_person: '🫄',
  breast_feeding: '🤱',
  woman_feeding_baby: '👩‍🍼',
  man_feeding_baby: '👨‍🍼',
  person_feeding_baby: '🧑‍🍼',
  angel: '👼',
  santa: '🎅',
  mrs_claus: '🤶',
  mx_claus: '🧑‍🎄',
  superhero: '🦸',
  superhero_man: '🦸‍♂',
  man_superhero: '🦸‍♂',
  superhero_woman: '🦸‍♀',
  woman_superhero: '🦸‍♀',
  supervillain: '🦹',
  supervillain_man: '🦹‍♂',
  man_supervillain: '🦹‍♂',
  supervillain_woman: '🦹‍♀',
  woman_supervillain: '🦹‍♀',
  mage: '🧙',
  mage_man: '🧙‍♂',
  man_mage: '🧙‍♂',
  mage_woman: '🧙‍♀',
  woman_mage: '🧙‍♀',
  fairy: '🧚',
  fairy_man: '🧚‍♂',
  man_fairy: '🧚‍♂',
  fairy_woman: '🧚‍♀',
  woman_fairy: '🧚‍♀',
  vampire: '🧛',
  vampire_man: '🧛‍♂',
  man_vampire: '🧛‍♂',
  vampire_woman: '🧛‍♀',
  woman_vampire: '🧛‍♀',
  merperson: '🧜',
  merman: '🧜‍♂',
  mermaid: '🧜‍♀',
  elf: '🧝',
  elf_man: '🧝‍♂',
  man_elf: '🧝‍♂',
  elf_woman: '🧝‍♀',
  woman_elf: '🧝‍♀',
  genie: '🧞',
  genie_man: '🧞‍♂',
  man_genie: '🧞‍♂',
  genie_woman: '🧞‍♀',
  woman_genie: '🧞‍♀',
  zombie: '🧟',
  zombie_man: '🧟‍♂',
  man_zombie: '🧟‍♂',
  zombie_woman: '🧟‍♀',
  woman_zombie: '🧟‍♀',
  troll: '🧌',
  massage: '💆',
  person_getting_massage: '💆',
  massage_man: '💆‍♂',
  man_getting_massage: '💆‍♂',
  massage_woman: '💆‍♀',
  woman_getting_massage: '💆‍♀',
  haircut: '💇',
  person_getting_haircut: '💇',
  haircut_man: '💇‍♂',
  man_getting_haircut: '💇‍♂',
  haircut_woman: '💇‍♀',
  woman_getting_haircut: '💇‍♀',
  walking: '🚶',
  person_walking: '🚶',
  walking_man: '🚶‍♂',
  man_walking: '🚶‍♂',
  walking_woman: '🚶‍♀',
  woman_walking: '🚶‍♀',
  person_walking_right: '🚶‍➡',
  woman_walking_right: '🚶‍♀‍➡️',
  man_walking_right: '🚶‍♂‍➡️',
  standing_person: '🧍',
  person_standing: '🧍',
  standing: '🧍',
  standing_man: '🧍‍♂',
  man_standing: '🧍‍♂',
  standing_woman: '🧍‍♀',
  woman_standing: '🧍‍♀',
  kneeling_person: '🧎',
  kneeling: '🧎',
  person_kneeling: '🧎',
  kneeling_man: '🧎‍♂',
  man_kneeling: '🧎‍♂',
  kneeling_woman: '🧎‍♀',
  woman_kneeling: '🧎‍♀',
  person_kneeling_right: '🧎‍➡',
  woman_kneeling_right: '🧎‍♀‍➡️',
  man_kneeling_right: '🧎‍♂‍➡️',
  person_with_probing_cane: '🧑‍🦯',
  person_with_white_cane: '🧑‍🦯',
  person_with_white_cane_right: '🧑‍🦯‍➡',
  man_with_probing_cane: '👨‍🦯',
  man_with_white_cane: '👨‍🦯',
  man_with_white_cane_right: '👨‍🦯‍➡',
  woman_with_probing_cane: '👩‍🦯',
  woman_with_white_cane: '👩‍🦯',
  woman_with_white_cane_right: '👩‍🦯‍➡',
  person_in_motorized_wheelchair: '🧑‍🦼',
  person_in_motorized_wheelchair_right: '🧑‍🦼‍➡',
  man_in_motorized_wheelchair: '👨‍🦼',
  man_in_motorized_wheelchair_right: '👨‍🦼‍➡',
  woman_in_motorized_wheelchair: '👩‍🦼',
  woman_in_motorized_wheelchair_right: '👩‍🦼‍➡',
  person_in_manual_wheelchair: '🧑‍🦽',
  person_in_manual_wheelchair_right: '🧑‍🦽‍➡',
  man_in_manual_wheelchair: '👨‍🦽',
  man_in_manual_wheelchair_right: '👨‍🦽‍➡',
  woman_in_manual_wheelchair: '👩‍🦽',
  woman_in_manual_wheelchair_right: '👩‍🦽‍➡',
  runner: '🏃',
  person_running: '🏃',
  running: '🏃',
  running_man: '🏃‍♂',
  man_running: '🏃‍♂',
  running_woman: '🏃‍♀',
  woman_running: '🏃‍♀',
  person_running_right: '🏃‍➡',
  woman_running_right: '🏃‍♀‍➡️',
  man_running_right: '🏃‍♂‍➡️',
  dancer: '💃',
  woman_dancing: '💃',
  man_dancing: '🕺',
  business_suit_levitating: '🕴',
  levitate: '🕴',
  levitating: '🕴',
  person_in_suit_levitating: '🕴',
  dancers: '👯',
  people_with_bunny_ears_partying: '👯',
  dancing_men: '👯‍♂',
  men_with_bunny_ears_partying: '👯‍♂',
  dancing_women: '👯‍♀',
  women_with_bunny_ears_partying: '👯‍♀',
  sauna_person: '🧖',
  person_in_steamy_room: '🧖',
  sauna_man: '🧖‍♂',
  man_in_steamy_room: '🧖‍♂',
  sauna_woman: '🧖‍♀',
  woman_in_steamy_room: '🧖‍♀',
  climbing: '🧗',
  person_climbing: '🧗',
  climbing_man: '🧗‍♂',
  man_climbing: '🧗‍♂',
  climbing_woman: '🧗‍♀',
  woman_climbing: '🧗‍♀',
  person_fencing: '🤺',
  fencer: '🤺',
  fencing: '🤺',
  horse_racing: '🏇',
  skier: '⛷',
  person_skiing: '⛷',
  skiing: '⛷',
  snowboarder: '🏂',
  person_snowboarding: '🏂',
  snowboarding: '🏂',
  golfing: '🏌',
  golfer: '🏌',
  person_golfing: '🏌',
  golfing_man: '🏌‍♂️',
  man_golfing: '🏌‍♂️',
  golfing_woman: '🏌‍♀️',
  woman_golfing: '🏌‍♀️',
  surfer: '🏄',
  person_surfing: '🏄',
  surfing: '🏄',
  surfing_man: '🏄‍♂',
  man_surfing: '🏄‍♂',
  surfing_woman: '🏄‍♀',
  woman_surfing: '🏄‍♀',
  rowboat: '🚣',
  person_rowing_boat: '🚣',
  rowing_man: '🚣‍♂',
  man_rowing_boat: '🚣‍♂',
  rowing_woman: '🚣‍♀',
  woman_rowing_boat: '🚣‍♀',
  swimmer: '🏊',
  person_swimming: '🏊',
  swimming: '🏊',
  swimming_man: '🏊‍♂',
  man_swimming: '🏊‍♂',
  swimming_woman: '🏊‍♀',
  woman_swimming: '🏊‍♀',
  bouncing_ball_person: '⛹',
  person_bouncing_ball: '⛹',
  basketball_man: '⛹‍♂️',
  man_bouncing_ball: '⛹‍♂️',
  basketball_woman: '⛹‍♀️',
  woman_bouncing_ball: '⛹‍♀️',
  weight_lifting: '🏋',
  person_lifting_weights: '🏋',
  weight_lifter: '🏋',
  weight_lifting_man: '🏋‍♂️',
  man_lifting_weights: '🏋‍♂️',
  weight_lifting_woman: '🏋‍♀️',
  woman_lifting_weights: '🏋‍♀️',
  bicyclist: '🚴',
  biking: '🚴',
  person_biking: '🚴',
  biking_man: '🚴‍♂',
  man_biking: '🚴‍♂',
  biking_woman: '🚴‍♀',
  woman_biking: '🚴‍♀',
  mountain_bicyclist: '🚵',
  mountain_biking: '🚵',
  person_mountain_biking: '🚵',
  mountain_biking_man: '🚵‍♂',
  man_mountain_biking: '🚵‍♂',
  mountain_biking_woman: '🚵‍♀',
  woman_mountain_biking: '🚵‍♀',
  cartwheeling: '🤸',
  person_cartwheel: '🤸',
  man_cartwheeling: '🤸‍♂',
  woman_cartwheeling: '🤸‍♀',
  wrestling: '🤼',
  people_wrestling: '🤼',
  wrestlers: '🤼',
  men_wrestling: '🤼‍♂',
  women_wrestling: '🤼‍♀',
  water_polo: '🤽',
  person_playing_water_polo: '🤽',
  man_playing_water_polo: '🤽‍♂',
  woman_playing_water_polo: '🤽‍♀',
  handball_person: '🤾',
  handball: '🤾',
  person_playing_handball: '🤾',
  man_playing_handball: '🤾‍♂',
  woman_playing_handball: '🤾‍♀',
  juggling_person: '🤹',
  juggler: '🤹',
  juggling: '🤹',
  person_juggling: '🤹',
  man_juggling: '🤹‍♂',
  woman_juggling: '🤹‍♀',
  lotus_position: '🧘',
  person_in_lotus_position: '🧘',
  lotus_position_man: '🧘‍♂',
  man_in_lotus_position: '🧘‍♂',
  lotus_position_woman: '🧘‍♀',
  woman_in_lotus_position: '🧘‍♀',
  bath: '🛀',
  person_taking_bath: '🛀',
  sleeping_bed: '🛌',
  person_in_bed: '🛌',
  sleeping_accommodation: '🛌',
  people_holding_hands: '🧑‍🤝‍🧑',
  two_women_holding_hands: '👭',
  couple: '👫',
  two_men_holding_hands: '👬',
  couplekiss: '💏',
  couple_kiss: '💏',
  couplekiss_man_woman: '👩‍❤‍💋‍👨',
  kiss_mw: '👩‍❤‍💋‍👨',
  kiss_wm: '👩‍❤‍💋‍👨',
  couplekiss_man_man: '👨‍❤‍💋‍👨',
  kiss_mm: '👨‍❤‍💋‍👨',
  couplekiss_woman_woman: '👩‍❤‍💋‍👩',
  kiss_ww: '👩‍❤‍💋‍👩',
  couple_with_heart: '💑',
  couple_with_heart_woman_man: '👩‍❤‍👨',
  couple_with_heart_mw: '👩‍❤‍👨',
  couple_with_heart_wm: '👩‍❤‍👨',
  couple_with_heart_man_man: '👨‍❤‍👨',
  couple_with_heart_mm: '👨‍❤‍👨',
  couple_with_heart_woman_woman: '👩‍❤‍👩',
  couple_with_heart_ww: '👩‍❤‍👩',
  family_man_woman_boy: '👨‍👩‍👦',
  family_mwb: '👨‍👩‍👦',
  family_man_woman_girl: '👨‍👩‍👧',
  family_mwg: '👨‍👩‍👧',
  family_man_woman_girl_boy: '👨‍👩‍👧‍👦',
  family_mwgb: '👨‍👩‍👧‍👦',
  family_man_woman_boy_boy: '👨‍👩‍👦‍👦',
  family_mwbb: '👨‍👩‍👦‍👦',
  family_man_woman_girl_girl: '👨‍👩‍👧‍👧',
  family_mwgg: '👨‍👩‍👧‍👧',
  family_man_man_boy: '👨‍👨‍👦',
  family_mmb: '👨‍👨‍👦',
  family_man_man_girl: '👨‍👨‍👧',
  family_mmg: '👨‍👨‍👧',
  family_man_man_girl_boy: '👨‍👨‍👧‍👦',
  family_mmgb: '👨‍👨‍👧‍👦',
  family_man_man_boy_boy: '👨‍👨‍👦‍👦',
  family_mmbb: '👨‍👨‍👦‍👦',
  family_man_man_girl_girl: '👨‍👨‍👧‍👧',
  family_mmgg: '👨‍👨‍👧‍👧',
  family_woman_woman_boy: '👩‍👩‍👦',
  family_wwb: '👩‍👩‍👦',
  family_woman_woman_girl: '👩‍👩‍👧',
  family_wwg: '👩‍👩‍👧',
  family_woman_woman_girl_boy: '👩‍👩‍👧‍👦',
  family_wwgb: '👩‍👩‍👧‍👦',
  family_woman_woman_boy_boy: '👩‍👩‍👦‍👦',
  family_wwbb: '👩‍👩‍👦‍👦',
  family_woman_woman_girl_girl: '👩‍👩‍👧‍👧',
  family_wwgg: '👩‍👩‍👧‍👧',
  family_man_boy: '👨‍👦',
  family_mb: '👨‍👦',
  family_man_boy_boy: '👨‍👦‍👦',
  family_mbb: '👨‍👦‍👦',
  family_man_girl: '👨‍👧',
  family_mg: '👨‍👧',
  family_man_girl_boy: '👨‍👧‍👦',
  family_mgb: '👨‍👧‍👦',
  family_man_girl_girl: '👨‍👧‍👧',
  family_mgg: '👨‍👧‍👧',
  family_woman_boy: '👩‍👦',
  family_wb: '👩‍👦',
  family_woman_boy_boy: '👩‍👦‍👦',
  family_wbb: '👩‍👦‍👦',
  family_woman_girl: '👩‍👧',
  family_wg: '👩‍👧',
  family_woman_girl_boy: '👩‍👧‍👦',
  family_wgb: '👩‍👧‍👦',
  family_woman_girl_girl: '👩‍👧‍👧',
  family_wgg: '👩‍👧‍👧',
  speaking_head: '🗣',
  bust_in_silhouette: '👤',
  busts_in_silhouette: '👥',
  people_hugging: '🫂',
  family: '👪',
  family_aac: '🧑‍🧑‍🧒',
  family_aacc: '🧑‍🧑‍🧒‍🧒',
  family_ac: '🧑‍🧒',
  family_acc: '🧑‍🧒‍🧒',
  footprints: '👣',
  tone1: '🏻',
  tone_light: '🏻',
  tone2: '🏼',
  tone_medium_light: '🏼',
  tone3: '🏽',
  tone_medium: '🏽',
  tone4: '🏾',
  tone_medium_dark: '🏾',
  tone5: '🏿',
  tone_dark: '🏿',
  red_hair: '🦰',
  curly_hair: '🦱',
  white_hair: '🦳',
  no_hair: '🦲',
  monkey_face: '🐵',
  monkey: '🐒',
  gorilla: '🦍',
  orangutan: '🦧',
  dog: '🐶',
  dog_face: '🐶',
  dog2: '🐕',
  guide_dog: '🦮',
  service_dog: '🐕‍🦺',
  poodle: '🐩',
  wolf: '🐺',
  wolf_face: '🐺',
  fox_face: '🦊',
  fox: '🦊',
  raccoon: '🦝',
  cat: '🐱',
  cat_face: '🐱',
  cat2: '🐈',
  black_cat: '🐈‍⬛',
  lion: '🦁',
  lion_face: '🦁',
  tiger: '🐯',
  tiger_face: '🐯',
  tiger2: '🐅',
  leopard: '🐆',
  horse: '🐴',
  horse_face: '🐴',
  moose: '🫎',
  donkey: '🫏',
  racehorse: '🐎',
  unicorn: '🦄',
  unicorn_face: '🦄',
  zebra: '🦓',
  deer: '🦌',
  bison: '🦬',
  cow: '🐮',
  cow_face: '🐮',
  ox: '🐂',
  water_buffalo: '🐃',
  cow2: '🐄',
  pig: '🐷',
  pig_face: '🐷',
  pig2: '🐖',
  boar: '🐗',
  pig_nose: '🐽',
  ram: '🐏',
  sheep: '🐑',
  ewe: '🐑',
  goat: '🐐',
  dromedary_camel: '🐪',
  camel: '🐫',
  llama: '🦙',
  giraffe: '🦒',
  elephant: '🐘',
  mammoth: '🦣',
  rhinoceros: '🦏',
  rhino: '🦏',
  hippopotamus: '🦛',
  hippo: '🦛',
  mouse: '🐭',
  mouse_face: '🐭',
  mouse2: '🐁',
  rat: '🐀',
  hamster: '🐹',
  hamster_face: '🐹',
  rabbit: '🐰',
  rabbit_face: '🐰',
  rabbit2: '🐇',
  chipmunk: '🐿',
  beaver: '🦫',
  hedgehog: '🦔',
  bat: '🦇',
  bear: '🐻',
  bear_face: '🐻',
  polar_bear: '🐻‍❄',
  polar_bear_face: '🐻‍❄',
  koala: '🐨',
  koala_face: '🐨',
  panda_face: '🐼',
  panda: '🐼',
  sloth: '🦥',
  otter: '🦦',
  skunk: '🦨',
  kangaroo: '🦘',
  badger: '🦡',
  feet: '🐾',
  paw_prints: '🐾',
  turkey: '🦃',
  chicken: '🐔',
  chicken_face: '🐔',
  rooster: '🐓',
  hatching_chick: '🐣',
  baby_chick: '🐤',
  hatched_chick: '🐥',
  bird: '🐦',
  bird_face: '🐦',
  penguin: '🐧',
  penguin_face: '🐧',
  dove: '🕊',
  eagle: '🦅',
  duck: '🦆',
  swan: '🦢',
  owl: '🦉',
  dodo: '🦤',
  feather: '🪶',
  flamingo: '🦩',
  peacock: '🦚',
  parrot: '🦜',
  wing: '🪽',
  black_bird: '🐦‍⬛',
  goose: '🪿',
  phoenix: '🐦‍🔥',
  frog: '🐸',
  frog_face: '🐸',
  crocodile: '🐊',
  turtle: '🐢',
  lizard: '🦎',
  snake: '🐍',
  dragon_face: '🐲',
  dragon: '🐉',
  sauropod: '🦕',
  't-rex': '🦖',
  trex: '🦖',
  whale: '🐳',
  spouting_whale: '🐳',
  whale2: '🐋',
  dolphin: '🐬',
  seal: '🦭',
  fish: '🐟',
  tropical_fish: '🐠',
  blowfish: '🐡',
  shark: '🦈',
  octopus: '🐙',
  shell: '🐚',
  coral: '🪸',
  jellyfish: '🪼',
  snail: '🐌',
  butterfly: '🦋',
  bug: '🐛',
  ant: '🐜',
  bee: '🐝',
  beetle: '🪲',
  lady_beetle: '🐞',
  cricket: '🦗',
  cockroach: '🪳',
  spider: '🕷',
  spider_web: '🕸',
  scorpion: '🦂',
  mosquito: '🦟',
  fly: '🪰',
  worm: '🪱',
  microbe: '🦠',
  bouquet: '💐',
  cherry_blossom: '🌸',
  white_flower: '💮',
  lotus: '🪷',
  rosette: '🏵',
  rose: '🌹',
  wilted_flower: '🥀',
  hibiscus: '🌺',
  sunflower: '🌻',
  blossom: '🌼',
  tulip: '🌷',
  hyacinth: '🪻',
  seedling: '🌱',
  potted_plant: '🪴',
  evergreen_tree: '🌲',
  deciduous_tree: '🌳',
  palm_tree: '🌴',
  cactus: '🌵',
  ear_of_rice: '🌾',
  sheaf_of_rice: '🌾',
  herb: '🌿',
  shamrock: '☘',
  four_leaf_clover: '🍀',
  maple_leaf: '🍁',
  fallen_leaf: '🍂',
  leaves: '🍃',
  empty_nest: '🪹',
  nest: '🪹',
  nest_with_eggs: '🪺',
  mushroom: '🍄',
  grapes: '🍇',
  melon: '🍈',
  watermelon: '🍉',
  mandarin: '🍊',
  orange: '🍊',
  tangerine: '🍊',
  lemon: '🍋',
  lime: '🍋‍🟩',
  banana: '🍌',
  pineapple: '🍍',
  mango: '🥭',
  apple: '🍎',
  red_apple: '🍎',
  green_apple: '🍏',
  pear: '🍐',
  peach: '🍑',
  cherries: '🍒',
  strawberry: '🍓',
  blueberries: '🫐',
  kiwi_fruit: '🥝',
  kiwi: '🥝',
  tomato: '🍅',
  olive: '🫒',
  coconut: '🥥',
  avocado: '🥑',
  eggplant: '🍆',
  potato: '🥔',
  carrot: '🥕',
  corn: '🌽',
  ear_of_corn: '🌽',
  hot_pepper: '🌶',
  bell_pepper: '🫑',
  cucumber: '🥒',
  leafy_green: '🥬',
  broccoli: '🥦',
  garlic: '🧄',
  onion: '🧅',
  peanuts: '🥜',
  beans: '🫘',
  chestnut: '🌰',
  ginger_root: '🫚',
  ginger: '🫚',
  pea_pod: '🫛',
  pea: '🫛',
  brown_mushroom: '🍄‍🟫',
  bread: '🍞',
  croissant: '🥐',
  baguette_bread: '🥖',
  flatbread: '🫓',
  pretzel: '🥨',
  bagel: '🥯',
  pancakes: '🥞',
  waffle: '🧇',
  cheese: '🧀',
  meat_on_bone: '🍖',
  poultry_leg: '🍗',
  cut_of_meat: '🥩',
  bacon: '🥓',
  hamburger: '🍔',
  fries: '🍟',
  french_fries: '🍟',
  pizza: '🍕',
  hotdog: '🌭',
  sandwich: '🥪',
  taco: '🌮',
  burrito: '🌯',
  tamale: '🫔',
  stuffed_flatbread: '🥙',
  falafel: '🧆',
  egg: '🥚',
  fried_egg: '🍳',
  cooking: '🍳',
  shallow_pan_of_food: '🥘',
  stew: '🍲',
  pot_of_food: '🍲',
  fondue: '🫕',
  bowl_with_spoon: '🥣',
  green_salad: '🥗',
  salad: '🥗',
  popcorn: '🍿',
  butter: '🧈',
  salt: '🧂',
  canned_food: '🥫',
  bento: '🍱',
  bento_box: '🍱',
  rice_cracker: '🍘',
  rice_ball: '🍙',
  rice: '🍚',
  cooked_rice: '🍚',
  curry: '🍛',
  curry_rice: '🍛',
  ramen: '🍜',
  steaming_bowl: '🍜',
  spaghetti: '🍝',
  sweet_potato: '🍠',
  oden: '🍢',
  sushi: '🍣',
  fried_shrimp: '🍤',
  fish_cake: '🍥',
  moon_cake: '🥮',
  dango: '🍡',
  dumpling: '🥟',
  fortune_cookie: '🥠',
  takeout_box: '🥡',
  crab: '🦀',
  lobster: '🦞',
  shrimp: '🦐',
  squid: '🦑',
  oyster: '🦪',
  icecream: '🍦',
  soft_serve: '🍦',
  shaved_ice: '🍧',
  ice_cream: '🍨',
  doughnut: '🍩',
  cookie: '🍪',
  birthday: '🎂',
  birthday_cake: '🎂',
  cake: '🍰',
  shortcake: '🍰',
  cupcake: '🧁',
  pie: '🥧',
  chocolate_bar: '🍫',
  candy: '🍬',
  lollipop: '🍭',
  custard: '🍮',
  honey_pot: '🍯',
  baby_bottle: '🍼',
  milk_glass: '🥛',
  glass_of_milk: '🥛',
  milk: '🥛',
  coffee: '☕',
  teapot: '🫖',
  tea: '🍵',
  sake: '🍶',
  champagne: '🍾',
  wine_glass: '🍷',
  cocktail: '🍸',
  tropical_drink: '🍹',
  beer: '🍺',
  beers: '🍻',
  clinking_glasses: '🥂',
  tumbler_glass: '🥃',
  whisky: '🥃',
  pouring_liquid: '🫗',
  pour: '🫗',
  cup_with_straw: '🥤',
  bubble_tea: '🧋',
  boba_drink: '🧋',
  beverage_box: '🧃',
  juice_box: '🧃',
  mate: '🧉',
  ice_cube: '🧊',
  ice: '🧊',
  chopsticks: '🥢',
  plate_with_cutlery: '🍽',
  fork_knife_plate: '🍽',
  fork_and_knife: '🍴',
  spoon: '🥄',
  hocho: '🔪',
  knife: '🔪',
  jar: '🫙',
  amphora: '🏺',
  earth_africa: '🌍',
  earth_europe: '🌍',
  earth_americas: '🌎',
  earth_asia: '🌏',
  globe_with_meridians: '🌐',
  world_map: '🗺',
  japan: '🗾',
  japan_map: '🗾',
  compass: '🧭',
  mountain_snow: '🏔',
  mountain: '⛰',
  volcano: '🌋',
  mount_fuji: '🗻',
  camping: '🏕',
  beach_umbrella: '🏖',
  beach: '🏖',
  beach_with_umbrella: '🏖',
  desert: '🏜',
  desert_island: '🏝',
  island: '🏝',
  national_park: '🏞',
  stadium: '🏟',
  classical_building: '🏛',
  building_construction: '🏗',
  construction_site: '🏗',
  bricks: '🧱',
  rock: '🪨',
  wood: '🪵',
  hut: '🛖',
  houses: '🏘',
  homes: '🏘',
  derelict_house: '🏚',
  house_abandoned: '🏚',
  house: '🏠',
  house_with_garden: '🏡',
  office: '🏢',
  post_office: '🏣',
  european_post_office: '🏤',
  hospital: '🏥',
  bank: '🏦',
  hotel: '🏨',
  love_hotel: '🏩',
  convenience_store: '🏪',
  school: '🏫',
  department_store: '🏬',
  factory: '🏭',
  japanese_castle: '🏯',
  european_castle: '🏰',
  castle: '🏰',
  wedding: '💒',
  tokyo_tower: '🗼',
  statue_of_liberty: '🗽',
  church: '⛪',
  mosque: '🕌',
  hindu_temple: '🛕',
  synagogue: '🕍',
  shinto_shrine: '⛩',
  kaaba: '🕋',
  fountain: '⛲',
  tent: '⛺',
  foggy: '🌁',
  night_with_stars: '🌃',
  cityscape: '🏙',
  sunrise_over_mountains: '🌄',
  sunrise: '🌅',
  city_sunset: '🌆',
  city_dusk: '🌆',
  city_sunrise: '🌇',
  bridge_at_night: '🌉',
  hotsprings: '♨',
  carousel_horse: '🎠',
  playground_slide: '🛝',
  slide: '🛝',
  ferris_wheel: '🎡',
  roller_coaster: '🎢',
  barber: '💈',
  barber_pole: '💈',
  circus_tent: '🎪',
  steam_locomotive: '🚂',
  railway_car: '🚃',
  bullettrain_side: '🚄',
  bullettrain_front: '🚅',
  train2: '🚆',
  train: '🚆',
  metro: '🚇',
  light_rail: '🚈',
  station: '🚉',
  tram: '🚊',
  monorail: '🚝',
  mountain_railway: '🚞',
  tram_car: '🚋',
  bus: '🚌',
  oncoming_bus: '🚍',
  trolleybus: '🚎',
  minibus: '🚐',
  ambulance: '🚑',
  fire_engine: '🚒',
  police_car: '🚓',
  oncoming_police_car: '🚔',
  taxi: '🚕',
  oncoming_taxi: '🚖',
  car: '🚗',
  red_car: '🚗',
  oncoming_automobile: '🚘',
  blue_car: '🚙',
  suv: '🚙',
  pickup_truck: '🛻',
  truck: '🚚',
  delivery_truck: '🚚',
  articulated_lorry: '🚛',
  tractor: '🚜',
  racing_car: '🏎',
  motorcycle: '🏍',
  motor_scooter: '🛵',
  manual_wheelchair: '🦽',
  motorized_wheelchair: '🦼',
  auto_rickshaw: '🛺',
  bike: '🚲',
  bicycle: '🚲',
  kick_scooter: '🛴',
  scooter: '🛴',
  skateboard: '🛹',
  roller_skate: '🛼',
  busstop: '🚏',
  motorway: '🛣',
  railway_track: '🛤',
  oil_drum: '🛢',
  fuelpump: '⛽',
  wheel: '🛞',
  rotating_light: '🚨',
  traffic_light: '🚥',
  vertical_traffic_light: '🚦',
  stop_sign: '🛑',
  octagonal_sign: '🛑',
  construction: '🚧',
  anchor: '⚓',
  ring_buoy: '🛟',
  lifebuoy: '🛟',
  boat: '⛵',
  sailboat: '⛵',
  canoe: '🛶',
  speedboat: '🚤',
  passenger_ship: '🛳',
  cruise_ship: '🛳',
  ferry: '⛴',
  motor_boat: '🛥',
  motorboat: '🛥',
  ship: '🚢',
  airplane: '✈',
  small_airplane: '🛩',
  flight_departure: '🛫',
  airplane_departure: '🛫',
  flight_arrival: '🛬',
  airplane_arriving: '🛬',
  parachute: '🪂',
  seat: '💺',
  helicopter: '🚁',
  suspension_railway: '🚟',
  mountain_cableway: '🚠',
  aerial_tramway: '🚡',
  artificial_satellite: '🛰',
  satellite: '🛰',
  rocket: '🚀',
  flying_saucer: '🛸',
  bellhop_bell: '🛎',
  bellhop: '🛎',
  luggage: '🧳',
  hourglass: '⌛',
  hourglass_flowing_sand: '⏳',
  watch: '⌚',
  alarm_clock: '⏰',
  stopwatch: '⏱',
  timer_clock: '⏲',
  mantelpiece_clock: '🕰',
  clock: '🕰',
  clock12: '🕛',
  clock1230: '🕧',
  clock1: '🕐',
  clock130: '🕜',
  clock2: '🕑',
  clock230: '🕝',
  clock3: '🕒',
  clock330: '🕞',
  clock4: '🕓',
  clock430: '🕟',
  clock5: '🕔',
  clock530: '🕠',
  clock6: '🕕',
  clock630: '🕡',
  clock7: '🕖',
  clock730: '🕢',
  clock8: '🕗',
  clock830: '🕣',
  clock9: '🕘',
  clock930: '🕤',
  clock10: '🕙',
  clock1030: '🕥',
  clock11: '🕚',
  clock1130: '🕦',
  new_moon: '🌑',
  waxing_crescent_moon: '🌒',
  first_quarter_moon: '🌓',
  moon: '🌔',
  waxing_gibbous_moon: '🌔',
  full_moon: '🌕',
  waning_gibbous_moon: '🌖',
  last_quarter_moon: '🌗',
  waning_crescent_moon: '🌘',
  crescent_moon: '🌙',
  new_moon_with_face: '🌚',
  first_quarter_moon_with_face: '🌛',
  last_quarter_moon_with_face: '🌜',
  thermometer: '🌡',
  sunny: '☀',
  sun: '☀',
  full_moon_with_face: '🌝',
  sun_with_face: '🌞',
  ringed_planet: '🪐',
  saturn: '🪐',
  star: '⭐',
  star2: '🌟',
  glowing_star: '🌟',
  stars: '🌠',
  shooting_star: '🌠',
  milky_way: '🌌',
  cloud: '☁',
  partly_sunny: '⛅',
  sun_behind_cloud: '⛅',
  cloud_with_lightning_and_rain: '⛈',
  stormy: '⛈',
  thunder_cloud_and_rain: '⛈',
  sun_behind_small_cloud: '🌤',
  sun_behind_large_cloud: '🌥',
  cloudy: '🌥',
  sun_behind_rain_cloud: '🌦',
  sun_and_rain: '🌦',
  cloud_with_rain: '🌧',
  rainy: '🌧',
  cloud_with_snow: '🌨',
  snowy: '🌨',
  cloud_with_lightning: '🌩',
  lightning: '🌩',
  tornado: '🌪',
  fog: '🌫',
  wind_face: '🌬',
  wind_blowing_face: '🌬',
  cyclone: '🌀',
  rainbow: '🌈',
  closed_umbrella: '🌂',
  open_umbrella: '☂',
  umbrella: '☂',
  umbrella_with_rain: '☔',
  parasol_on_ground: '⛱',
  umbrella_on_ground: '⛱',
  zap: '⚡',
  high_voltage: '⚡',
  snowflake: '❄',
  snowman_with_snow: '☃',
  snowman2: '☃',
  snowman: '⛄',
  comet: '☄',
  fire: '🔥',
  droplet: '💧',
  ocean: '🌊',
  water_wave: '🌊',
  jack_o_lantern: '🎃',
  christmas_tree: '🎄',
  fireworks: '🎆',
  sparkler: '🎇',
  firecracker: '🧨',
  sparkles: '✨',
  balloon: '🎈',
  tada: '🎉',
  party: '🎉',
  party_popper: '🎉',
  confetti_ball: '🎊',
  tanabata_tree: '🎋',
  bamboo: '🎍',
  dolls: '🎎',
  flags: '🎏',
  carp_streamer: '🎏',
  wind_chime: '🎐',
  rice_scene: '🎑',
  moon_ceremony: '🎑',
  red_envelope: '🧧',
  ribbon: '🎀',
  gift: '🎁',
  reminder_ribbon: '🎗',
  tickets: '🎟',
  admission_tickets: '🎟',
  ticket: '🎫',
  medal_military: '🎖',
  military_medal: '🎖',
  trophy: '🏆',
  medal_sports: '🏅',
  sports_medal: '🏅',
  '1st_place_medal': '🥇',
  '1st': '🥇',
  first_place_medal: '🥇',
  '2nd_place_medal': '🥈',
  '2nd': '🥈',
  second_place_medal: '🥈',
  '3rd_place_medal': '🥉',
  '3rd': '🥉',
  third_place_medal: '🥉',
  soccer: '⚽',
  baseball: '⚾',
  softball: '🥎',
  basketball: '🏀',
  volleyball: '🏐',
  football: '🏈',
  rugby_football: '🏉',
  tennis: '🎾',
  flying_disc: '🥏',
  bowling: '🎳',
  cricket_game: '🏏',
  field_hockey: '🏑',
  ice_hockey: '🏒',
  hockey: '🏒',
  lacrosse: '🥍',
  ping_pong: '🏓',
  badminton: '🏸',
  boxing_glove: '🥊',
  martial_arts_uniform: '🥋',
  goal_net: '🥅',
  golf: '⛳',
  ice_skate: '⛸',
  fishing_pole_and_fish: '🎣',
  fishing_pole: '🎣',
  diving_mask: '🤿',
  running_shirt_with_sash: '🎽',
  running_shirt: '🎽',
  ski: '🎿',
  sled: '🛷',
  curling_stone: '🥌',
  dart: '🎯',
  bullseye: '🎯',
  direct_hit: '🎯',
  yo_yo: '🪀',
  kite: '🪁',
  gun: '🔫',
  pistol: '🔫',
  '8ball': '🎱',
  billiards: '🎱',
  crystal_ball: '🔮',
  magic_wand: '🪄',
  video_game: '🎮',
  controller: '🎮',
  joystick: '🕹',
  slot_machine: '🎰',
  game_die: '🎲',
  jigsaw: '🧩',
  puzzle_piece: '🧩',
  teddy_bear: '🧸',
  pinata: '🪅',
  mirror_ball: '🪩',
  disco: '🪩',
  disco_ball: '🪩',
  nesting_dolls: '🪆',
  spades: '♠',
  hearts: '♥',
  diamonds: '♦',
  clubs: '♣',
  chess_pawn: '♟',
  black_joker: '🃏',
  mahjong: '🀄',
  flower_playing_cards: '🎴',
  performing_arts: '🎭',
  framed_picture: '🖼',
  frame_with_picture: '🖼',
  art: '🎨',
  palette: '🎨',
  thread: '🧵',
  sewing_needle: '🪡',
  yarn: '🧶',
  knot: '🪢',
  eyeglasses: '👓',
  glasses: '👓',
  dark_sunglasses: '🕶',
  goggles: '🥽',
  lab_coat: '🥼',
  safety_vest: '🦺',
  necktie: '👔',
  shirt: '👕',
  jeans: '👖',
  scarf: '🧣',
  gloves: '🧤',
  coat: '🧥',
  socks: '🧦',
  dress: '👗',
  kimono: '👘',
  sari: '🥻',
  one_piece_swimsuit: '🩱',
  swim_brief: '🩲',
  briefs: '🩲',
  shorts: '🩳',
  bikini: '👙',
  womans_clothes: '👚',
  folding_hand_fan: '🪭',
  folding_fan: '🪭',
  purse: '👛',
  handbag: '👜',
  pouch: '👝',
  clutch_bag: '👝',
  shopping: '🛍',
  shopping_bags: '🛍',
  school_satchel: '🎒',
  backpack: '🎒',
  thong_sandal: '🩴',
  mans_shoe: '👞',
  athletic_shoe: '👟',
  sneaker: '👟',
  hiking_boot: '🥾',
  flat_shoe: '🥿',
  womans_flat_shoe: '🥿',
  high_heel: '👠',
  sandal: '👡',
  ballet_shoes: '🩰',
  boot: '👢',
  hair_pick: '🪮',
  crown: '👑',
  womans_hat: '👒',
  tophat: '🎩',
  top_hat: '🎩',
  mortar_board: '🎓',
  graduation_cap: '🎓',
  billed_cap: '🧢',
  military_helmet: '🪖',
  rescue_worker_helmet: '⛑',
  helmet_with_cross: '⛑',
  prayer_beads: '📿',
  lipstick: '💄',
  ring: '💍',
  gem: '💎',
  mute: '🔇',
  no_sound: '🔇',
  speaker: '🔈',
  low_volume: '🔈',
  quiet_sound: '🔈',
  sound: '🔉',
  medium_volumne: '🔉',
  loud_sound: '🔊',
  high_volume: '🔊',
  loudspeaker: '📢',
  mega: '📣',
  megaphone: '📣',
  postal_horn: '📯',
  bell: '🔔',
  no_bell: '🔕',
  musical_score: '🎼',
  musical_note: '🎵',
  notes: '🎶',
  musical_notes: '🎶',
  studio_microphone: '🎙',
  level_slider: '🎚',
  control_knobs: '🎛',
  microphone: '🎤',
  headphones: '🎧',
  radio: '📻',
  saxophone: '🎷',
  accordion: '🪗',
  guitar: '🎸',
  musical_keyboard: '🎹',
  trumpet: '🎺',
  violin: '🎻',
  banjo: '🪕',
  drum: '🥁',
  long_drum: '🪘',
  maracas: '🪇',
  flute: '🪈',
  iphone: '📱',
  android: '📱',
  mobile_phone: '📱',
  calling: '📲',
  mobile_phone_arrow: '📲',
  phone: '☎',
  telephone: '☎',
  telephone_receiver: '📞',
  pager: '📟',
  fax: '📠',
  fax_machine: '📠',
  battery: '🔋',
  low_battery: '🪫',
  electric_plug: '🔌',
  computer: '💻',
  laptop: '💻',
  desktop_computer: '🖥',
  printer: '🖨',
  keyboard: '⌨',
  computer_mouse: '🖱',
  trackball: '🖲',
  minidisc: '💽',
  computer_disk: '💽',
  floppy_disk: '💾',
  cd: '💿',
  optical_disk: '💿',
  dvd: '📀',
  abacus: '🧮',
  movie_camera: '🎥',
  film_strip: '🎞',
  film_frames: '🎞',
  film_projector: '📽',
  clapper: '🎬',
  tv: '📺',
  camera: '📷',
  camera_flash: '📸',
  camera_with_flash: '📸',
  video_camera: '📹',
  vhs: '📼',
  videocassette: '📼',
  mag: '🔍',
  mag_right: '🔎',
  candle: '🕯',
  bulb: '💡',
  light_bulb: '💡',
  flashlight: '🔦',
  izakaya_lantern: '🏮',
  red_paper_lantern: '🏮',
  diya_lamp: '🪔',
  notebook_with_decorative_cover: '📔',
  closed_book: '📕',
  book: '📖',
  open_book: '📖',
  green_book: '📗',
  blue_book: '📘',
  orange_book: '📙',
  books: '📚',
  notebook: '📓',
  ledger: '📒',
  page_with_curl: '📃',
  scroll: '📜',
  page_facing_up: '📄',
  newspaper: '📰',
  newspaper_roll: '🗞',
  rolled_up_newspaper: '🗞',
  bookmark_tabs: '📑',
  bookmark: '🔖',
  label: '🏷',
  moneybag: '💰',
  coin: '🪙',
  yen: '💴',
  dollar: '💵',
  euro: '💶',
  pound: '💷',
  money_with_wings: '💸',
  credit_card: '💳',
  receipt: '🧾',
  chart: '💹',
  envelope: '✉',
  'e-mail': '📧',
  email: '📧',
  incoming_envelope: '📨',
  envelope_with_arrow: '📩',
  outbox_tray: '📤',
  inbox_tray: '📥',
  package: '📦',
  mailbox: '📫',
  mailbox_closed: '📪',
  mailbox_with_mail: '📬',
  mailbox_with_no_mail: '📭',
  postbox: '📮',
  ballot_box: '🗳',
  pencil2: '✏',
  pencil: '✏',
  black_nib: '✒',
  fountain_pen: '🖋',
  pen: '🖊',
  paintbrush: '🖌',
  crayon: '🖍',
  memo: '📝',
  briefcase: '💼',
  file_folder: '📁',
  open_file_folder: '📂',
  card_index_dividers: '🗂',
  date: '📅',
  calendar: '📆',
  spiral_notepad: '🗒',
  notepad_spiral: '🗒',
  spiral_calendar: '🗓',
  calendar_spiral: '🗓',
  card_index: '📇',
  chart_with_upwards_trend: '📈',
  chart_increasing: '📈',
  chart_with_downwards_trend: '📉',
  chart_decreasing: '📉',
  bar_chart: '📊',
  clipboard: '📋',
  pushpin: '📌',
  round_pushpin: '📍',
  paperclip: '📎',
  paperclips: '🖇',
  straight_ruler: '📏',
  triangular_ruler: '📐',
  scissors: '✂',
  card_file_box: '🗃',
  file_cabinet: '🗄',
  wastebasket: '🗑',
  trashcan: '🗑',
  lock: '🔒',
  locked: '🔒',
  unlock: '🔓',
  unlocked: '🔓',
  lock_with_ink_pen: '🔏',
  locked_with_pen: '🔏',
  closed_lock_with_key: '🔐',
  locked_with_key: '🔐',
  key: '🔑',
  old_key: '🗝',
  hammer: '🔨',
  axe: '🪓',
  pick: '⛏',
  hammer_and_pick: '⚒',
  hammer_and_wrench: '🛠',
  dagger: '🗡',
  crossed_swords: '⚔',
  bomb: '💣',
  boomerang: '🪃',
  bow_and_arrow: '🏹',
  shield: '🛡',
  carpentry_saw: '🪚',
  wrench: '🔧',
  screwdriver: '🪛',
  nut_and_bolt: '🔩',
  gear: '⚙',
  clamp: '🗜',
  compression: '🗜',
  balance_scale: '⚖',
  scales: '⚖',
  probing_cane: '🦯',
  white_cane: '🦯',
  link: '🔗',
  broken_chain: '⛓‍💥',
  chains: '⛓',
  hook: '🪝',
  toolbox: '🧰',
  magnet: '🧲',
  ladder: '🪜',
  alembic: '⚗',
  test_tube: '🧪',
  petri_dish: '🧫',
  dna: '🧬',
  double_helix: '🧬',
  microscope: '🔬',
  telescope: '🔭',
  satellite_antenna: '📡',
  syringe: '💉',
  drop_of_blood: '🩸',
  pill: '💊',
  adhesive_bandage: '🩹',
  bandaid: '🩹',
  crutch: '🩼',
  stethoscope: '🩺',
  x_ray: '🩻',
  'x-ray': '🩻',
  xray: '🩻',
  door: '🚪',
  elevator: '🛗',
  mirror: '🪞',
  window: '🪟',
  bed: '🛏',
  couch_and_lamp: '🛋',
  chair: '🪑',
  toilet: '🚽',
  plunger: '🪠',
  shower: '🚿',
  bathtub: '🛁',
  mouse_trap: '🪤',
  razor: '🪒',
  lotion_bottle: '🧴',
  safety_pin: '🧷',
  broom: '🧹',
  basket: '🧺',
  roll_of_paper: '🧻',
  toilet_paper: '🧻',
  bucket: '🪣',
  soap: '🧼',
  bubbles: '🫧',
  toothbrush: '🪥',
  sponge: '🧽',
  fire_extinguisher: '🧯',
  shopping_cart: '🛒',
  smoking: '🚬',
  cigarette: '🚬',
  coffin: '⚰',
  headstone: '🪦',
  funeral_urn: '⚱',
  nazar_amulet: '🧿',
  hamsa: '🪬',
  moyai: '🗿',
  moai: '🗿',
  placard: '🪧',
  identification_card: '🪪',
  id_card: '🪪',
  atm: '🏧',
  put_litter_in_its_place: '🚮',
  litter_bin: '🚮',
  potable_water: '🚰',
  wheelchair: '♿',
  handicapped: '♿',
  mens: '🚹',
  womens: '🚺',
  restroom: '🚻',
  bathroom: '🚻',
  baby_symbol: '🚼',
  wc: '🚾',
  water_closet: '🚾',
  passport_control: '🛂',
  customs: '🛃',
  baggage_claim: '🛄',
  left_luggage: '🛅',
  warning: '⚠',
  children_crossing: '🚸',
  no_entry: '⛔',
  no_entry_sign: '🚫',
  no_bicycles: '🚳',
  no_smoking: '🚭',
  do_not_litter: '🚯',
  no_littering: '🚯',
  'non-potable_water': '🚱',
  no_pedestrians: '🚷',
  no_mobile_phones: '📵',
  underage: '🔞',
  no_one_under_18: '🔞',
  radioactive: '☢',
  biohazard: '☣',
  arrow_up: '⬆',
  arrow_upper_right: '↗',
  arrow_right: '➡',
  arrow_lower_right: '↘',
  arrow_down: '⬇',
  arrow_lower_left: '↙',
  arrow_left: '⬅',
  arrow_upper_left: '↖',
  arrow_up_down: '↕',
  left_right_arrow: '↔',
  leftwards_arrow_with_hook: '↩',
  arrow_left_hook: '↩',
  arrow_right_hook: '↪',
  rightwards_arrow_with_hook: '↪',
  arrow_heading_up: '⤴',
  arrow_heading_down: '⤵',
  arrows_clockwise: '🔃',
  clockwise: '🔃',
  arrows_counterclockwise: '🔄',
  counterclockwise: '🔄',
  back: '🔙',
  end: '🔚',
  on: '🔛',
  soon: '🔜',
  top: '🔝',
  place_of_worship: '🛐',
  atom_symbol: '⚛',
  atom: '⚛',
  om: '🕉',
  star_of_david: '✡',
  wheel_of_dharma: '☸',
  yin_yang: '☯',
  latin_cross: '✝',
  orthodox_cross: '☦',
  star_and_crescent: '☪',
  peace_symbol: '☮',
  peace: '☮',
  menorah: '🕎',
  six_pointed_star: '🔯',
  khanda: '🪯',
  aries: '♈',
  taurus: '♉',
  gemini: '♊',
  cancer: '♋',
  leo: '♌',
  virgo: '♍',
  libra: '♎',
  scorpius: '♏',
  sagittarius: '♐',
  capricorn: '♑',
  aquarius: '♒',
  pisces: '♓',
  ophiuchus: '⛎',
  twisted_rightwards_arrows: '🔀',
  shuffle: '🔀',
  repeat: '🔁',
  repeat_one: '🔂',
  arrow_forward: '▶',
  play: '▶',
  fast_forward: '⏩',
  next_track_button: '⏭',
  next_track: '⏭',
  play_or_pause_button: '⏯',
  play_pause: '⏯',
  arrow_backward: '◀',
  reverse: '◀',
  rewind: '⏪',
  fast_reverse: '⏪',
  previous_track_button: '⏮',
  previous_track: '⏮',
  arrow_up_small: '🔼',
  up: '🔼',
  arrow_double_up: '⏫',
  fast_up: '⏫',
  arrow_down_small: '🔽',
  down: '🔽',
  arrow_double_down: '⏬',
  fast_down: '⏬',
  pause_button: '⏸',
  pause: '⏸',
  stop_button: '⏹',
  stop: '⏹',
  record_button: '⏺',
  record: '⏺',
  eject_button: '⏏',
  eject: '⏏',
  cinema: '🎦',
  low_brightness: '🔅',
  dim_button: '🔅',
  high_brightness: '🔆',
  bright_button: '🔆',
  signal_strength: '📶',
  antenna_bars: '📶',
  wireless: '🛜',
  vibration_mode: '📳',
  mobile_phone_off: '📴',
  female_sign: '♀',
  female: '♀',
  male_sign: '♂',
  male: '♂',
  transgender_symbol: '⚧',
  heavy_multiplication_x: '✖',
  multiplication: '✖',
  multiply: '✖',
  heavy_plus_sign: '➕',
  plus: '➕',
  heavy_minus_sign: '➖',
  minus: '➖',
  heavy_division_sign: '➗',
  divide: '➗',
  division: '➗',
  heavy_equals_sign: '🟰',
  infinity: '♾',
  bangbang: '‼',
  double_exclamation: '‼',
  interrobang: '⁉',
  exclamation_question: '⁉',
  question: '❓',
  grey_question: '❔',
  white_question: '❔',
  grey_exclamation: '❕',
  white_exclamation: '❕',
  exclamation: '❗',
  wavy_dash: '〰',
  currency_exchange: '💱',
  heavy_dollar_sign: '💲',
  medical_symbol: '⚕',
  medical: '⚕',
  recycle: '♻',
  recycling_symbol: '♻',
  fleur_de_lis: '⚜',
  'fleur-de-lis': '⚜',
  trident: '🔱',
  name_badge: '📛',
  beginner: '🔰',
  o: '⭕',
  hollow_red_circle: '⭕',
  red_o: '⭕',
  white_check_mark: '✅',
  check_mark_button: '✅',
  ballot_box_with_check: '☑',
  heavy_check_mark: '✔',
  check_mark: '✔',
  x: '❌',
  cross_mark: '❌',
  negative_squared_cross_mark: '❎',
  cross_mark_button: '❎',
  curly_loop: '➰',
  loop: '➿',
  double_curly_loop: '➿',
  part_alternation_mark: '〽',
  eight_spoked_asterisk: '✳',
  eight_pointed_black_star: '✴',
  sparkle: '❇',
  copyright: '©',
  registered: '®',
  tm: '™',
  trade_mark: '™',
  hash: '#⃣',
  number_sign: '#⃣',
  asterisk: '*⃣',
  zero: '0⃣',
  one: '1⃣',
  two: '2⃣',
  three: '3⃣',
  four: '4⃣',
  five: '5⃣',
  six: '6⃣',
  seven: '7⃣',
  eight: '8⃣',
  nine: '9⃣',
  keycap_ten: '🔟',
  ten: '🔟',
  capital_abcd: '🔠',
  abcd: '🔡',
  symbols: '🔣',
  abc: '🔤',
  a: '🅰',
  a_blood: '🅰',
  ab: '🆎',
  ab_blood: '🆎',
  b: '🅱',
  b_blood: '🅱',
  cl: '🆑',
  cool: '🆒',
  free: '🆓',
  information_source: 'ℹ',
  info: 'ℹ',
  id: '🆔',
  m: 'Ⓜ',
  'new': '🆕',
  ng: '🆖',
  o2: '🅾',
  o_blood: '🅾',
  ok: '🆗',
  parking: '🅿',
  sos: '🆘',
  up2: '🆙',
  vs: '🆚',
  koko: '🈁',
  ja_here: '🈁',
  sa: '🈂',
  ja_service_charge: '🈂',
  u6708: '🈷',
  ja_monthly_amount: '🈷',
  u6709: '🈶',
  ja_not_free_of_carge: '🈶',
  u6307: '🈯',
  ja_reserved: '🈯',
  ideograph_advantage: '🉐',
  ja_bargain: '🉐',
  u5272: '🈹',
  ja_discount: '🈹',
  u7121: '🈚',
  ja_free_of_charge: '🈚',
  u7981: '🈲',
  ja_prohibited: '🈲',
  accept: '🉑',
  ja_acceptable: '🉑',
  u7533: '🈸',
  ja_application: '🈸',
  u5408: '🈴',
  ja_passing_grade: '🈴',
  u7a7a: '🈳',
  ja_vacancy: '🈳',
  congratulations: '㊗',
  ja_congratulations: '㊗',
  secret: '㊙',
  ja_secret: '㊙',
  u55b6: '🈺',
  ja_open_for_business: '🈺',
  u6e80: '🈵',
  ja_no_vacancy: '🈵',
  red_circle: '🔴',
  orange_circle: '🟠',
  yellow_circle: '🟡',
  green_circle: '🟢',
  large_blue_circle: '🔵',
  blue_circle: '🔵',
  purple_circle: '🟣',
  brown_circle: '🟤',
  black_circle: '⚫',
  white_circle: '⚪',
  red_square: '🟥',
  orange_square: '🟧',
  yellow_square: '🟨',
  green_square: '🟩',
  blue_square: '🟦',
  purple_square: '🟪',
  brown_square: '🟫',
  black_large_square: '⬛',
  white_large_square: '⬜',
  black_medium_square: '◼',
  white_medium_square: '◻',
  black_medium_small_square: '◾',
  white_medium_small_square: '◽',
  black_small_square: '▪',
  white_small_square: '▫',
  large_orange_diamond: '🔶',
  large_blue_diamond: '🔷',
  small_orange_diamond: '🔸',
  small_blue_diamond: '🔹',
  small_red_triangle: '🔺',
  small_red_triangle_down: '🔻',
  diamond_shape_with_a_dot_inside: '💠',
  diamond_with_a_dot: '💠',
  radio_button: '🔘',
  white_square_button: '🔳',
  black_square_button: '🔲',
  checkered_flag: '🏁',
  triangular_flag_on_post: '🚩',
  triangular_flag: '🚩',
  crossed_flags: '🎌',
  black_flag: '🏴',
  white_flag: '🏳',
  rainbow_flag: '🏳‍🌈',
  transgender_flag: '🏳‍⚧️',
  pirate_flag: '🏴‍☠',
  jolly_roger: '🏴‍☠',
  ascension_island: '🇦🇨',
  flag_ac: '🇦🇨',
  andorra: '🇦🇩',
  flag_ad: '🇦🇩',
  united_arab_emirates: '🇦🇪',
  flag_ae: '🇦🇪',
  afghanistan: '🇦🇫',
  flag_af: '🇦🇫',
  antigua_barbuda: '🇦🇬',
  flag_ag: '🇦🇬',
  anguilla: '🇦🇮',
  flag_ai: '🇦🇮',
  albania: '🇦🇱',
  flag_al: '🇦🇱',
  armenia: '🇦🇲',
  flag_am: '🇦🇲',
  angola: '🇦🇴',
  flag_ao: '🇦🇴',
  antarctica: '🇦🇶',
  flag_aq: '🇦🇶',
  argentina: '🇦🇷',
  flag_ar: '🇦🇷',
  american_samoa: '🇦🇸',
  flag_as: '🇦🇸',
  austria: '🇦🇹',
  flag_at: '🇦🇹',
  australia: '🇦🇺',
  flag_au: '🇦🇺',
  aruba: '🇦🇼',
  flag_aw: '🇦🇼',
  aland_islands: '🇦🇽',
  flag_ax: '🇦🇽',
  azerbaijan: '🇦🇿',
  flag_az: '🇦🇿',
  bosnia_herzegovina: '🇧🇦',
  flag_ba: '🇧🇦',
  barbados: '🇧🇧',
  flag_bb: '🇧🇧',
  bangladesh: '🇧🇩',
  flag_bd: '🇧🇩',
  belgium: '🇧🇪',
  flag_be: '🇧🇪',
  burkina_faso: '🇧🇫',
  flag_bf: '🇧🇫',
  bulgaria: '🇧🇬',
  flag_bg: '🇧🇬',
  bahrain: '🇧🇭',
  flag_bh: '🇧🇭',
  burundi: '🇧🇮',
  flag_bi: '🇧🇮',
  benin: '🇧🇯',
  flag_bj: '🇧🇯',
  st_barthelemy: '🇧🇱',
  flag_bl: '🇧🇱',
  bermuda: '🇧🇲',
  flag_bm: '🇧🇲',
  brunei: '🇧🇳',
  flag_bn: '🇧🇳',
  bolivia: '🇧🇴',
  flag_bo: '🇧🇴',
  caribbean_netherlands: '🇧🇶',
  flag_bq: '🇧🇶',
  brazil: '🇧🇷',
  flag_br: '🇧🇷',
  bahamas: '🇧🇸',
  flag_bs: '🇧🇸',
  bhutan: '🇧🇹',
  flag_bt: '🇧🇹',
  bouvet_island: '🇧🇻',
  flag_bv: '🇧🇻',
  botswana: '🇧🇼',
  flag_bw: '🇧🇼',
  belarus: '🇧🇾',
  flag_by: '🇧🇾',
  belize: '🇧🇿',
  flag_bz: '🇧🇿',
  canada: '🇨🇦',
  flag_ca: '🇨🇦',
  cocos_islands: '🇨🇨',
  flag_cc: '🇨🇨',
  congo_kinshasa: '🇨🇩',
  flag_cd: '🇨🇩',
  central_african_republic: '🇨🇫',
  flag_cf: '🇨🇫',
  congo_brazzaville: '🇨🇬',
  flag_cg: '🇨🇬',
  switzerland: '🇨🇭',
  flag_ch: '🇨🇭',
  cote_divoire: '🇨🇮',
  flag_ci: '🇨🇮',
  cook_islands: '🇨🇰',
  flag_ck: '🇨🇰',
  chile: '🇨🇱',
  flag_cl: '🇨🇱',
  cameroon: '🇨🇲',
  flag_cm: '🇨🇲',
  cn: '🇨🇳',
  china: '🇨🇳',
  flag_cn: '🇨🇳',
  colombia: '🇨🇴',
  flag_co: '🇨🇴',
  clipperton_island: '🇨🇵',
  flag_cp: '🇨🇵',
  costa_rica: '🇨🇷',
  flag_cr: '🇨🇷',
  cuba: '🇨🇺',
  flag_cu: '🇨🇺',
  cape_verde: '🇨🇻',
  flag_cv: '🇨🇻',
  curacao: '🇨🇼',
  flag_cw: '🇨🇼',
  christmas_island: '🇨🇽',
  flag_cx: '🇨🇽',
  cyprus: '🇨🇾',
  flag_cy: '🇨🇾',
  czech_republic: '🇨🇿',
  czechia: '🇨🇿',
  flag_cz: '🇨🇿',
  de: '🇩🇪',
  flag_de: '🇩🇪',
  germany: '🇩🇪',
  diego_garcia: '🇩🇬',
  flag_dg: '🇩🇬',
  djibouti: '🇩🇯',
  flag_dj: '🇩🇯',
  denmark: '🇩🇰',
  flag_dk: '🇩🇰',
  dominica: '🇩🇲',
  flag_dm: '🇩🇲',
  dominican_republic: '🇩🇴',
  flag_do: '🇩🇴',
  algeria: '🇩🇿',
  flag_dz: '🇩🇿',
  ceuta_melilla: '🇪🇦',
  flag_ea: '🇪🇦',
  ecuador: '🇪🇨',
  flag_ec: '🇪🇨',
  estonia: '🇪🇪',
  flag_ee: '🇪🇪',
  egypt: '🇪🇬',
  flag_eg: '🇪🇬',
  western_sahara: '🇪🇭',
  flag_eh: '🇪🇭',
  eritrea: '🇪🇷',
  flag_er: '🇪🇷',
  es: '🇪🇸',
  flag_es: '🇪🇸',
  spain: '🇪🇸',
  ethiopia: '🇪🇹',
  flag_et: '🇪🇹',
  eu: '🇪🇺',
  european_union: '🇪🇺',
  flag_eu: '🇪🇺',
  finland: '🇫🇮',
  flag_fi: '🇫🇮',
  fiji: '🇫🇯',
  flag_fj: '🇫🇯',
  falkland_islands: '🇫🇰',
  flag_fk: '🇫🇰',
  micronesia: '🇫🇲',
  flag_fm: '🇫🇲',
  faroe_islands: '🇫🇴',
  flag_fo: '🇫🇴',
  fr: '🇫🇷',
  flag_fr: '🇫🇷',
  france: '🇫🇷',
  gabon: '🇬🇦',
  flag_ga: '🇬🇦',
  gb: '🇬🇧',
  flag_gb: '🇬🇧',
  uk: '🇬🇧',
  united_kingdom: '🇬🇧',
  grenada: '🇬🇩',
  flag_gd: '🇬🇩',
  georgia: '🇬🇪',
  flag_ge: '🇬🇪',
  french_guiana: '🇬🇫',
  flag_gf: '🇬🇫',
  guernsey: '🇬🇬',
  flag_gg: '🇬🇬',
  ghana: '🇬🇭',
  flag_gh: '🇬🇭',
  gibraltar: '🇬🇮',
  flag_gi: '🇬🇮',
  greenland: '🇬🇱',
  flag_gl: '🇬🇱',
  gambia: '🇬🇲',
  flag_gm: '🇬🇲',
  guinea: '🇬🇳',
  flag_gn: '🇬🇳',
  guadeloupe: '🇬🇵',
  flag_gp: '🇬🇵',
  equatorial_guinea: '🇬🇶',
  flag_gq: '🇬🇶',
  greece: '🇬🇷',
  flag_gr: '🇬🇷',
  south_georgia_south_sandwich_islands: '🇬🇸',
  flag_gs: '🇬🇸',
  guatemala: '🇬🇹',
  flag_gt: '🇬🇹',
  guam: '🇬🇺',
  flag_gu: '🇬🇺',
  guinea_bissau: '🇬🇼',
  flag_gw: '🇬🇼',
  guyana: '🇬🇾',
  flag_gy: '🇬🇾',
  hong_kong: '🇭🇰',
  flag_hk: '🇭🇰',
  heard_mcdonald_islands: '🇭🇲',
  flag_hm: '🇭🇲',
  honduras: '🇭🇳',
  flag_hn: '🇭🇳',
  croatia: '🇭🇷',
  flag_hr: '🇭🇷',
  haiti: '🇭🇹',
  flag_ht: '🇭🇹',
  hungary: '🇭🇺',
  flag_hu: '🇭🇺',
  canary_islands: '🇮🇨',
  flag_ic: '🇮🇨',
  indonesia: '🇮🇩',
  flag_id: '🇮🇩',
  ireland: '🇮🇪',
  flag_ie: '🇮🇪',
  israel: '🇮🇱',
  flag_il: '🇮🇱',
  isle_of_man: '🇮🇲',
  flag_im: '🇮🇲',
  india: '🇮🇳',
  flag_in: '🇮🇳',
  british_indian_ocean_territory: '🇮🇴',
  flag_io: '🇮🇴',
  iraq: '🇮🇶',
  flag_iq: '🇮🇶',
  iran: '🇮🇷',
  flag_ir: '🇮🇷',
  iceland: '🇮🇸',
  flag_is: '🇮🇸',
  it: '🇮🇹',
  flag_it: '🇮🇹',
  italy: '🇮🇹',
  jersey: '🇯🇪',
  flag_je: '🇯🇪',
  jamaica: '🇯🇲',
  flag_jm: '🇯🇲',
  jordan: '🇯🇴',
  flag_jo: '🇯🇴',
  jp: '🇯🇵',
  flag_jp: '🇯🇵',
  kenya: '🇰🇪',
  flag_ke: '🇰🇪',
  kyrgyzstan: '🇰🇬',
  flag_kg: '🇰🇬',
  cambodia: '🇰🇭',
  flag_kh: '🇰🇭',
  kiribati: '🇰🇮',
  flag_ki: '🇰🇮',
  comoros: '🇰🇲',
  flag_km: '🇰🇲',
  st_kitts_nevis: '🇰🇳',
  flag_kn: '🇰🇳',
  north_korea: '🇰🇵',
  flag_kp: '🇰🇵',
  kr: '🇰🇷',
  flag_kr: '🇰🇷',
  south_korea: '🇰🇷',
  kuwait: '🇰🇼',
  flag_kw: '🇰🇼',
  cayman_islands: '🇰🇾',
  flag_ky: '🇰🇾',
  kazakhstan: '🇰🇿',
  flag_kz: '🇰🇿',
  laos: '🇱🇦',
  flag_la: '🇱🇦',
  lebanon: '🇱🇧',
  flag_lb: '🇱🇧',
  st_lucia: '🇱🇨',
  flag_lc: '🇱🇨',
  liechtenstein: '🇱🇮',
  flag_li: '🇱🇮',
  sri_lanka: '🇱🇰',
  flag_lk: '🇱🇰',
  liberia: '🇱🇷',
  flag_lr: '🇱🇷',
  lesotho: '🇱🇸',
  flag_ls: '🇱🇸',
  lithuania: '🇱🇹',
  flag_lt: '🇱🇹',
  luxembourg: '🇱🇺',
  flag_lu: '🇱🇺',
  latvia: '🇱🇻',
  flag_lv: '🇱🇻',
  libya: '🇱🇾',
  flag_ly: '🇱🇾',
  morocco: '🇲🇦',
  flag_ma: '🇲🇦',
  monaco: '🇲🇨',
  flag_mc: '🇲🇨',
  moldova: '🇲🇩',
  flag_md: '🇲🇩',
  montenegro: '🇲🇪',
  flag_me: '🇲🇪',
  st_martin: '🇲🇫',
  flag_mf: '🇲🇫',
  madagascar: '🇲🇬',
  flag_mg: '🇲🇬',
  marshall_islands: '🇲🇭',
  flag_mh: '🇲🇭',
  macedonia: '🇲🇰',
  flag_mk: '🇲🇰',
  mali: '🇲🇱',
  flag_ml: '🇲🇱',
  myanmar: '🇲🇲',
  burma: '🇲🇲',
  flag_mm: '🇲🇲',
  mongolia: '🇲🇳',
  flag_mn: '🇲🇳',
  macau: '🇲🇴',
  flag_mo: '🇲🇴',
  macao: '🇲🇴',
  northern_mariana_islands: '🇲🇵',
  flag_mp: '🇲🇵',
  martinique: '🇲🇶',
  flag_mq: '🇲🇶',
  mauritania: '🇲🇷',
  flag_mr: '🇲🇷',
  montserrat: '🇲🇸',
  flag_ms: '🇲🇸',
  malta: '🇲🇹',
  flag_mt: '🇲🇹',
  mauritius: '🇲🇺',
  flag_mu: '🇲🇺',
  maldives: '🇲🇻',
  flag_mv: '🇲🇻',
  malawi: '🇲🇼',
  flag_mw: '🇲🇼',
  mexico: '🇲🇽',
  flag_mx: '🇲🇽',
  malaysia: '🇲🇾',
  flag_my: '🇲🇾',
  mozambique: '🇲🇿',
  flag_mz: '🇲🇿',
  namibia: '🇳🇦',
  flag_na: '🇳🇦',
  new_caledonia: '🇳🇨',
  flag_nc: '🇳🇨',
  niger: '🇳🇪',
  flag_ne: '🇳🇪',
  norfolk_island: '🇳🇫',
  flag_nf: '🇳🇫',
  nigeria: '🇳🇬',
  flag_ng: '🇳🇬',
  nicaragua: '🇳🇮',
  flag_ni: '🇳🇮',
  netherlands: '🇳🇱',
  flag_nl: '🇳🇱',
  norway: '🇳🇴',
  flag_no: '🇳🇴',
  nepal: '🇳🇵',
  flag_np: '🇳🇵',
  nauru: '🇳🇷',
  flag_nr: '🇳🇷',
  niue: '🇳🇺',
  flag_nu: '🇳🇺',
  new_zealand: '🇳🇿',
  flag_nz: '🇳🇿',
  oman: '🇴🇲',
  flag_om: '🇴🇲',
  panama: '🇵🇦',
  flag_pa: '🇵🇦',
  peru: '🇵🇪',
  flag_pe: '🇵🇪',
  french_polynesia: '🇵🇫',
  flag_pf: '🇵🇫',
  papua_new_guinea: '🇵🇬',
  flag_pg: '🇵🇬',
  philippines: '🇵🇭',
  flag_ph: '🇵🇭',
  pakistan: '🇵🇰',
  flag_pk: '🇵🇰',
  poland: '🇵🇱',
  flag_pl: '🇵🇱',
  st_pierre_miquelon: '🇵🇲',
  flag_pm: '🇵🇲',
  pitcairn_islands: '🇵🇳',
  flag_pn: '🇵🇳',
  puerto_rico: '🇵🇷',
  flag_pr: '🇵🇷',
  palestinian_territories: '🇵🇸',
  flag_ps: '🇵🇸',
  portugal: '🇵🇹',
  flag_pt: '🇵🇹',
  palau: '🇵🇼',
  flag_pw: '🇵🇼',
  paraguay: '🇵🇾',
  flag_py: '🇵🇾',
  qatar: '🇶🇦',
  flag_qa: '🇶🇦',
  reunion: '🇷🇪',
  flag_re: '🇷🇪',
  romania: '🇷🇴',
  flag_ro: '🇷🇴',
  serbia: '🇷🇸',
  flag_rs: '🇷🇸',
  ru: '🇷🇺',
  flag_ru: '🇷🇺',
  russia: '🇷🇺',
  rwanda: '🇷🇼',
  flag_rw: '🇷🇼',
  saudi_arabia: '🇸🇦',
  flag_sa: '🇸🇦',
  solomon_islands: '🇸🇧',
  flag_sb: '🇸🇧',
  seychelles: '🇸🇨',
  flag_sc: '🇸🇨',
  sudan: '🇸🇩',
  flag_sd: '🇸🇩',
  sweden: '🇸🇪',
  flag_se: '🇸🇪',
  singapore: '🇸🇬',
  flag_sg: '🇸🇬',
  st_helena: '🇸🇭',
  flag_sh: '🇸🇭',
  slovenia: '🇸🇮',
  flag_si: '🇸🇮',
  svalbard_jan_mayen: '🇸🇯',
  flag_sj: '🇸🇯',
  slovakia: '🇸🇰',
  flag_sk: '🇸🇰',
  sierra_leone: '🇸🇱',
  flag_sl: '🇸🇱',
  san_marino: '🇸🇲',
  flag_sm: '🇸🇲',
  senegal: '🇸🇳',
  flag_sn: '🇸🇳',
  somalia: '🇸🇴',
  flag_so: '🇸🇴',
  suriname: '🇸🇷',
  flag_sr: '🇸🇷',
  south_sudan: '🇸🇸',
  flag_ss: '🇸🇸',
  sao_tome_principe: '🇸🇹',
  flag_st: '🇸🇹',
  el_salvador: '🇸🇻',
  flag_sv: '🇸🇻',
  sint_maarten: '🇸🇽',
  flag_sx: '🇸🇽',
  syria: '🇸🇾',
  flag_sy: '🇸🇾',
  swaziland: '🇸🇿',
  eswatini: '🇸🇿',
  flag_sz: '🇸🇿',
  tristan_da_cunha: '🇹🇦',
  flag_ta: '🇹🇦',
  turks_caicos_islands: '🇹🇨',
  flag_tc: '🇹🇨',
  chad: '🇹🇩',
  flag_td: '🇹🇩',
  french_southern_territories: '🇹🇫',
  flag_tf: '🇹🇫',
  togo: '🇹🇬',
  flag_tg: '🇹🇬',
  thailand: '🇹🇭',
  flag_th: '🇹🇭',
  tajikistan: '🇹🇯',
  flag_tj: '🇹🇯',
  tokelau: '🇹🇰',
  flag_tk: '🇹🇰',
  timor_leste: '🇹🇱',
  flag_tl: '🇹🇱',
  turkmenistan: '🇹🇲',
  flag_tm: '🇹🇲',
  tunisia: '🇹🇳',
  flag_tn: '🇹🇳',
  tonga: '🇹🇴',
  flag_to: '🇹🇴',
  tr: '🇹🇷',
  flag_tr: '🇹🇷',
  turkey_tr: '🇹🇷',
  trinidad_tobago: '🇹🇹',
  flag_tt: '🇹🇹',
  tuvalu: '🇹🇻',
  flag_tv: '🇹🇻',
  taiwan: '🇹🇼',
  flag_tw: '🇹🇼',
  tanzania: '🇹🇿',
  flag_tz: '🇹🇿',
  ukraine: '🇺🇦',
  flag_ua: '🇺🇦',
  uganda: '🇺🇬',
  flag_ug: '🇺🇬',
  us_outlying_islands: '🇺🇲',
  flag_um: '🇺🇲',
  united_nations: '🇺🇳',
  flag_un: '🇺🇳',
  un: '🇺🇳',
  us: '🇺🇸',
  flag_us: '🇺🇸',
  united_states: '🇺🇸',
  usa: '🇺🇸',
  uruguay: '🇺🇾',
  flag_uy: '🇺🇾',
  uzbekistan: '🇺🇿',
  flag_uz: '🇺🇿',
  vatican_city: '🇻🇦',
  flag_va: '🇻🇦',
  st_vincent_grenadines: '🇻🇨',
  flag_vc: '🇻🇨',
  venezuela: '🇻🇪',
  flag_ve: '🇻🇪',
  british_virgin_islands: '🇻🇬',
  flag_vg: '🇻🇬',
  us_virgin_islands: '🇻🇮',
  flag_vi: '🇻🇮',
  vietnam: '🇻🇳',
  flag_vn: '🇻🇳',
  vanuatu: '🇻🇺',
  flag_vu: '🇻🇺',
  wallis_futuna: '🇼🇫',
  flag_wf: '🇼🇫',
  samoa: '🇼🇸',
  flag_ws: '🇼🇸',
  kosovo: '🇽🇰',
  flag_xk: '🇽🇰',
  yemen: '🇾🇪',
  flag_ye: '🇾🇪',
  mayotte: '🇾🇹',
  flag_yt: '🇾🇹',
  south_africa: '🇿🇦',
  flag_za: '🇿🇦',
  zambia: '🇿🇲',
  flag_zm: '🇿🇲',
  zimbabwe: '🇿🇼',
  flag_zw: '🇿🇼',
  england: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  flag_gbeng: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  scotland: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  flag_gbsct: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  wales: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  flag_gbwls: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
};
